module.exports = __webpack_public_path__ + "static/media/DrumMachine.f70cae2f.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/DrumMachine.JPG
// module id = 286
// module chunks = 0